import axios from "axios";

export const getSatinfoStat = () => axios("/stats/satinfo/");
export const getMissionsStat = () => axios("/stats/missions/");
